<!-- 自定义组别-新增/编辑 -->
<template>
  <a-spin :spinning="loading">
    <j-modal
      title="自定义组别"
      centered
      :width="550"
      :ok="false"
      :visible="visible"
      @ok="handleSubmit"
      @cancel="handleCancel"
      dialogClass="resize-for-mobile"
    >
      <a-form-model ref="form" :model="form" @keyup.enter.native="handleSubmit" :rules="rules" class="hide-scroll">
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="组别名称" prop="groupName">
          <a-input :placeholder="$t('disp.ph.input', ['组别名称'])" v-model="form.groupName" :maxLength="100" />
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="组别内组织" prop="groupText">
          <j-input-popup
            v-model="departs"
            component="SelectExternalDepartModal"
            placeholder="请选择组别内组织"
            :params="{
              companyId: '',
              departName: '',
              multiFlg: '1',
              departFlg: '1',
              searchFlg: '0',
            }"
            @change="departSelectChange"
          ></j-input-popup>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="标记色" prop="markColor">
          <a-select placeholder="标记色" v-model="form.markColor" style="width: 104px">
            <a-select-option v-for="i in XEUtils.filter(colorList, (r) => r.key != 'blue')" :key="i.key" :value="i.key">
              <span class="markColor-block" :style="'background-color:' + i.color" style="margin-right: 0px"></span>
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <!--	排序　-->
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.sort')" prop="sortOrder">
          <a-input-number
            style="width: 104px"
            :placeholder="$t('disp.sort')"
            v-model="form.sortOrder"
            :min="0"
            :max="999"
          />
        </a-form-model-item>
      </a-form-model>
    </j-modal>
  </a-spin>
</template>
<script>
import { mixin, mixinDevice } from '@/utils/mixin.js'
import { colorList } from '@/components/tools/setting.js'
import { httpAction, getAction } from '@/api/manage'
import JInputNumber from '@/components/JInputNumber'
import JSelectDepartTree from '@/components/JSelectDepartTree'

class formDef {
  id = undefined
  userId = undefined
  groupName = undefined
  groupType = undefined
  groupText = undefined
  groupJson = undefined
  sortOrder = 99
  createBy = undefined
  createTime = undefined
  updateBy = undefined
  updateTime = undefined
  markColor = undefined
  isModal = undefined
  delFlag = 0
  groupDeparts = []
  groupDepartNames = undefined
}

export default {
  name: 'ExternalDepartGroup',
  mixins: [mixin, mixinDevice],
  components: { JInputNumber, JSelectDepartTree },
  props: {
    // 是否弹出框
    groupType: {
      type: Boolean,
      default: 'externalDepart',
    },
  },
  data() {
    return {
      loading: false,
      visible: false,
      form: new formDef(),
      colorList,
      departs: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 19 },
      },
      rules: {
        groupName: [this._r.required],
        groupText: [this._r.required],
        markColor: [this._r.required],
        sortOrder: [this._r.required],
      },
      url: {
        groupSaveOrUpdate: '/blaze-sys/sys/group/groupSaveOrUpdate',
      },
    }
  },
  computed: {},
  methods: {
    add() {
      // 使用form定义初始化form
      this.form = new formDef()
      this.form.groupType = this.groupType
      this.form.userId = this.$getLoginUser().id
      this.form.isModal = 'add'
      this.departs = []
      this.visible = true
    },
    edit(record) {
      this.form = new formDef()
      this.form = Object.assign({}, record)
      this.form.userId = this.$getLoginUser().id
      this.form.isModal = 'edit'

      this.departs = []
      if (this.form.groupJson) {
        let groupJson = XEUtils.toStringJSON(this.form.groupJson)
        groupJson.forEach((item) => {
          this.departs.push({
            text: '[' + item.sysName + ']' + item.name,
            value: item.sysCode + '_' + item.id,
          })
        })
      }
      this.visible = true
    },
    handleSubmit() {
      this.$refs.form.validateFieldsAndScroll((ok) => {
        if (ok) {
          if (this.loading) {
            return
          } else {
            this.loading = true
          }

          httpAction(this.url.groupSaveOrUpdate, this.form, 'post')
            .then((res) => {
              if (res.success) {
                this.$message.success(this.$t(res.message))
                this.$emit('emit', res.message)
                this.visible = false
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    departSelectChange() {
      if (this.departs && this.departs.length > 0) {
        this.form.groupText = XEUtils.map(this.departs, (item) => item.id).join(',')
        this.form.groupJson = XEUtils.toJSONString(
          XEUtils.map(this.departs, (item) => {
            return {
              id: item.originalId,
              name: item.departName,
              orgCode: item.orgCode,
              sysCode: item.systemCode,
              sysName: item.systemName,
              sort: item.sortOrder,
            }
          })
        )
      } else {
        this.form.groupText = ''
        this.form.groupJson = ''
      }
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>
<style lang="less" scoped>
.markColor-block {
  width: 50px;
  height: 11px;
  display: inline-block !important;
}
/deep/ .ant-select-search__field__placeholder {
  left: 10px !important;
}
</style>
